import api from '@/api/api'
import router from '@/router/index'
import {
    axiosInstance
} from '@/helpers/axiosInterceptor';
import {
    Notification
} from 'element-ui'

const state = {
    autoConfirmation: localStorage.getItem('auto') ? localStorage.getItem('auto')  : false,
    rates: [],
    rates_error: undefined
}

const getters = {
    getAutoConfirmation: state => state.autoConfirmation,
    getRates: state => state.rates,
    getRatesError: state => state.rates_error
}

const mutations = {
    SET_AUTO(state, auto) {
        localStorage.setItem('auto', auto)
        state.autoConfirmation = auto
    },
    SET_ERROR(state, error) {
        state.rates_error = error
    },
    EMPTY_RATES(state) {
        state.rates = []
    },
    SAVE_RATE(state, rate) {
        state.rates.push(rate)
    },
    async REMOVE_RATE(state, rate) {

        let response

        await api.deleteRates(rate)
            .then((res) => {
                response = res
                console.log('err', response)
            })
            .catch((err) => {
                response = err.data
                console.log('err', response)
            })

        for (let item of state.rates) {
            if (item.id === rate) {
                let index = state.rates.indexOf(item)
                state.rates.splice(index, 1)
            }
        }
    },
    async UPDATE_RATE(state, rate) {
        let index
        for (let item of state.rates) {
            if (item.id == rate.id) {
                index = state.rates.indexOf(item)
            }
        }
        state.rates[index] = rate
    }
}

const actions = {

    updateAutoConfirmation ( {commit}, auto) {
        localStorage.setItem('auto', auto)
        commit('SET_AUTO', auto)
    },
    async addRate( {commit}, rate) {
        let response
        await api.saveRate(rate)
		.then((res) => {
			response = res
		})
		.catch((err) => {
			response = err.data
			console.log('err', response)
		})

        if (response.status == 201) {
            commit('SAVE_RATE', response.data.data)

            Notification.success({
                title: 'Success',
                message: 'Rate has been successfully added.'
            })

            // router.push('/dashboard/rates')
            return {status: 'success', rate: response.data.data}

        } else if (response.type == 'validation_error') {
            commit('SET_ERROR', response.fields)
            return response.fields
        }

    },

    async confirmSingleRate ({commit}, id) {
        let dist = await api.confirmSingleRate(id)
        if (dist.data === "") {
            Notification.success({
                title: 'Success',
                message: 'Rate has been successfully confirmed.'
            })
        }
        
    },

    async confirmRates ({commit}, rates) {
        let dist = await api.confirmRates(rates)
        if (dist.data === "") {
            Notification.success({
                title: 'Success',
                message: 'Rates have been successfully confirmed.'
            })
        }
        
    },

    async fetchRates({commit}) {
        let dist = await api.fetchRates()
        dist = dist.data.data
        commit('EMPTY_RATES')
        dist.forEach(function (elem) {
            commit('SAVE_RATE', elem)
        })
    },

    async fetchProviderRates({commit}, id) {
        let dist = await api.fetchProviderRates(id)        
        dist = dist.data.data
        commit('EMPTY_RATES')
        dist.forEach(function (elem) {
            commit('SAVE_RATE', elem)
        })
    },

    async fetchAllRates({commit}) {
        let dist = await api.fetchAllRates()
        dist = dist.data.data
        commit('EMPTY_RATES')
        dist.forEach(function (elem) {
            commit('SAVE_RATE', elem)
        })
    },

    async removeRate({commit}, rate) {
        commit('REMOVE_RATE', rate)
    },

    async updateRate({commit}, rate) {
        let response
        await api.updateRate(rate.id, rate)
		.then((res) => {
            response = res
		})
		.catch((err) => {
            response = err.data
			console.log('err', err)
        })
        if (response.status === 200) {
            commit('UPDATE_RATE', rate)
            Notification.success({
                title: 'Success',
                message: 'Rate has been successfully updated.'
            })
            return {status: 'success', rate: response.data.data}
        } else if (response.type === 'validation_error') {
            return response.fields
        }
        
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/rates.js